/*
Backbone MainView
*/
//require react view
// import Page from './component/page.jsx';
import App from './app.jsx';

export default Backbone.View.extend({
  el: '#wrapper',
  render(currentView) {
  	ReactDOM.render(
  		<App>
  			{currentView}
  		</App>,this.el
  	);
  }
})



// WEBPACK FOOTER //
// src/js/view/index.js